/* eslint-disable react/jsx-filename-extension */
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * IframeWrapper component
 *
 * @file IframeWrapper.jsx
 * @author Ujjwal Sana
 * @since 0.0.1
 */

import React, {
  memo
} from 'react';
import PropTypes from 'prop-types';

const IframeWrapper = ({ embeddedUrl = '/aet/instructor/dashboard' }) => (
  <div style={{ height: '100vh' }}>
    <iframe
      src={embeddedUrl}
      title="Dashboard in Iframe"
      width="100%"
      height="100%"
      style={{ border: 0, display: 'block' }}
    />
  </div>
);

IframeWrapper.propTypes = {
  embeddedUrl: PropTypes.string.isRequired
};

export default memo(IframeWrapper);
